import React from 'react';

import { imgPath } from '~commonInfra/utils/ImgUrl';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { DraftBanner, DraftBannerAction } from '~src/drafts/components/DraftBanner';
import {
  deletePublishedConnectionDraft
} from '~src/publishedConnection/actions/DeletePublishedConnectionDraftReduxAction';
import { editPublishedConnectionDraft } from '~src/publishedConnection/actions/EditPublishedConnectionDraftReduxAction';
import { IPublishedConnectionDraftInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';

export type PublishedConnectionDraftBannerProps = {
  readonly publishedConnectionDraft: IPublishedConnectionDraftInfo;
};

export function PublishedConnectionDraftBanner(props: PublishedConnectionDraftBannerProps): JSX.Element {
  if (!props.publishedConnectionDraft.luid) {
    return null;
  }

  const handleEditDraft = () => {
      getAppStore().dispatch(editPublishedConnectionDraft(props.publishedConnectionDraft.luid));
  };

  const handleDeleteDraft = () => {
      getAppStore().dispatch(deletePublishedConnectionDraft(props.publishedConnectionDraft.luid));
  };

  const continueEditBannerAction: DraftBannerAction = {
    label: Messages.continueEditing(),
    handleAction: handleEditDraft,
    iconPath: imgPath('pencil_14px_small.svg'),
    testId: 'continue-editing'
  };

  const deleteDraftBannerAction: DraftBannerAction = {
    label: Messages.deleteDraft(),
    handleAction: handleDeleteDraft,
    iconPath: imgPath('trash_14px_small.svg'),
    testId: 'delete-draft'
  };

  return (
    <DraftBanner
      lastEditDate={props.publishedConnectionDraft.updatedAt}
      draftBannerActions={[continueEditBannerAction, deleteDraftBannerAction]}
      contentTypeName={Messages.virtualConnectionLowerCase()}
    />
  );
}
